module.exports = __webpack_public_path__ + "media/icons/chevron-down-9665b0c178b26c8341b04a28bdab147f.svg";